export const isLiveDate = ({ startDate, endDate }) => {
  if (!startDate || !endDate) {
    return false;
  }
  const now = Date.now();
  const start = new Date(startDate).getTime();
  const end = new Date(endDate).getTime();

  return now >= start && now <= end;
};
